<template>

  <!-- v-on:beforeEnter="onOverlayBeforeEnter" -->
<transition
  :css="false"
  v-on:enter="onOverlayEnter"
  v-on:leave="onOverlayLeave"
>
  <div class="sidebar-overlay"
    v-if="isSidebarOpen"
    v-on:click="toggleSidebar(false, $event)"
  >
  </div>
</transition>

<transition>
  <div class="sidebar" v-if="isSidebarOpen">
    <button class="btn-close" v-on:click="toggleSidebar(false, $event)">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L19 18.9999M1 19L19 1" stroke="#5A5A5A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <SidebarGroup
      v-for="list, i in lists"
      :key="i"
      :title="list.title"
      :items="list.items"
    />
  </div>
</transition>

</template>

<script>
import gsap from 'gsap'
import SidebarGroup from './SidebarGroup'

import {getSecurityItems, getImageItems} from '@/tree'

export default {
  data() {
    return {
      isOpen: false,
      lists: [
        {
          title: "for Image",
          items: getImageItems()
          // [
          //   {name: "deep_tagging", label: "Deep Tagging", isPreparing: false, routeName: "DeepTagging"},
          //   {name: "deep_lens", label: "Deep Lens", isPreparing: false, routeName: "DeepLens"},
          //   {name: "logo", label: "Logo", isPreparing: false, routeName: "DeepLens"},
          //   {name: "landmark", label: "Landmark", isPreparing: false, routeName: "Landmark"},
          //   {name: "OCR", label: "OCR", isPreparing: true},
          //   {name: "image_inpainting", label: "Image Inpaiting", isPreparing: true},
          // ]
        },
        {
          title: "for Security",
          items: getSecurityItems()
          // [
          //   {name: "safety_lens", label: "Safety Lens", isPreparing: false, routeName: "SafetyLens"},
          //   {name: "fire_lens", label: "Fire Lens", isPreparing: false, routeName: "FireLens"},
          //   {name: "face_lens", label: "Face Lens", isPreparing: false, routeName: "FaceLens"},
          //   {name: "leak_lens", label: "Leak Lens", isPreparing: false, routeName: "LeakLens"},
          // ]
        },
      ]
    }
  },
  methods: {
    toggleSidebar(doOpen) {
      this.$store.commit('toggleSidebar', doOpen)
    },
    onOverlayEnter(el, done) {
      gsap.fromTo(el, {
        opacity: 0
      }, {
        duration: 0.3,
        opacity: 1,
        onComplete: done
      })
    },
    onOverlayLeave(el, done) {
      gsap.fromTo(el, {
        opacity: 1
      }, {
        duration: 0.3,
        opacity: 0,
        onComplete: done
      })
    },
    // onSidebarEnter(el, done) {
    //   gsap.fromTo(el, {
    //     x: "-100%"
    //   }, {
    //     duration: 0.3,
    //     x: "0%",
    //     clearProps: 'all',
    //     onComplete: ()=> {
    //       this.isOpen = true
    //       done()
    //     }
    //   })
    // },
    // onSidebarLeave(el, done) {
    //   gsap.fromTo(el, {
    //     x: "0%"
    //   }, {
    //     duration: 0.3,
    //     x: "-100%",
    //     clearProps: 'all',
    //     onComplete: ()=> {
    //       this.isOpen = false
    //       done()
    //     }
    //   })
    // },
  },
  computed: {
    isSidebarOpen() {
      return this.$store.getters.isSidebarOpen
    }
  },
  components: {
    SidebarGroup
  }
}
</script>


<style lang="scss">

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 100;
  opacity: 0;
}

.sidebar {
  --sidebar-width: 400px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: var(--sidebar-width);
  background-color: white;
  z-index: 200;
  padding: 65px 40px 16px 54px;
  box-shadow: 4px 0px 30px rgba(0, 0, 0, 0.1);
  // transform: translate3d(0%, 0, 0);
  transition: transform 300ms;
  overflow-y: auto;
  @media screen and (max-width: 1104px) {
    right: 0;
    left: auto;
  }
  @media screen and (max-width: 768px) {
    --sidebar-width: 300px;
    padding: 30px 16px;
  }
  @media screen and (max-width: 540px) {
    --sidebar-width: 250px;
  }
}

.sidebar.v-enter-from,
.sidebar.v-leave-to {
  transform: translate3d(-100%, 0, 0);
  @media screen and (max-width: 1104px) {
    transform: translate3d(100%, 0, 0);
  }
}
.sidebar.v-enter-to,
.sidebar.v-leave-from {
  transform: translate3d(0%, 0, 0);
}


.btn-close {
  width: 48px;
  height: 48px;
  padding: 15px;
  margin-left: calc(100% - 48px);
  margin-bottom: 5px;
  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
  }
  @media screen and (max-width: 540px) {
    padding: 5px;
    width: 30px;
    height: 30px;
    margin-left: calc(100% - 30px);
    margin-bottom: 28px;
  }
}

.btn-close svg {
  display: block;
  width: 100%;
  height: 100%;
}
</style>